import request from '@/utils/request'


export function getOrderInfo(id) {
  return request({
    url: '/order/orderInfo/'+id,
    method: 'get'
  })
}
export function createOrder(productId) {
  return request({
    url: '/alipay/createOrder',
    method: 'post',
    params:{ productId: productId }
  })
}
export function getAdvanceOrderInfo(orderNum) {
  return request({
    url: '/order/advancePayOrder/'+orderNum,
    method: 'get'
  })
}
export function getPay(orderNum) {
  return request({
    url: '/alipay/goAlipay',
    method: 'get',
    params: {orderId: orderNum}
  })
}
export function alipayReturnNotice(param) {
  return request({
    url: '/alipay/alipayReturnNotice',
    method: 'post',
    params: param
  })
}

export function getOrderInfoByState(state) {
  return request({
    url: '/order/getOrderInfo',
    method: 'get',
    params:{state:state}
  })
}
export function deleteOrder(orderNum) {
  return request({
    url: '/order/deleteOrder/'+orderNum,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/order.js